import { useStaticQuery, graphql } from 'gatsby'

const resourcesQuery = graphql`
  query {
    PRAConfigurator: allContentfulNavigationElement(
      filter: { navigation_id: { eq: "PRA Configurator" } }
    ) {
      nodes {
        navigation_id
        node_locale
        slug
        navigation_element {
          slug
          navigation_element {
            slug
            navigation_element {
              slug
              navigation_element {
                slug
                navigation_element {
                  slug
                  navigation_element {
                    slug
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const useGenericConfiguratorNavigation = (locale, navigationId) => {
  const { PRAConfigurator } = useStaticQuery(resourcesQuery)

  switch (navigationId) {
    case 'PRA Configurator':
      let navigationElement
      PRAConfigurator.nodes.forEach((element) => {
        if (element.node_locale === locale) {
          navigationElement = element
        }
      })
      return navigationElement
    default:
      return null
  }
}
